import { stopStreamResponse, showElement, hideElement } from "./plugin-edit-ai";
import { popconfirm } from "./utils/popconfirm";
import createElement from "./utils/createElement";

const SELECTORS = {
    INPUT: 'ask-ai-input',
    TOOLTIP: 'ask-ai-tooltip',
    RESPONSE_DROPDOWN: 'ai-response-dropdown',
    ACTIONS_DROPDOWN: 'ai-actions-dropdown',
}

/**
 * @type {WysiwygConfigOptions}
 */
let options = {};

const languages = [
    'English',
    'Korean',
    'Chineese',
    'Japanese',
    'Spanish',
    'Russian',
    'French',
    'Portuguese',
    'German',
    'Italian',
    'Dutch',
    'Indonesian',
    'Filipino',
    'Polish',
]

const translateIcon = `
<svg class='dropdown-item-icon' style="width:16px; height:16px; fill:#444;"  viewBox="0 0 640 512" xmlns="http://www.w3.org/2000/svg">
  <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
  <path d="M0 128C0 92.7 28.7 64 64 64H256h48 16H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H320 304 256 64c-35.3 0-64-28.7-64-64V128zm320 0V384H576V128H320zM178.3 175.9c-3.2-7.2-10.4-11.9-18.3-11.9s-15.1 4.7-18.3 11.9l-64 144c-4.5 10.1 .1 21.9 10.2 26.4s21.9-.1 26.4-10.2l8.9-20.1h73.6l8.9 20.1c4.5 10.1 16.3 14.6 26.4 10.2s14.6-16.3 10.2-26.4l-64-144zM160 233.2L179 276H141l19-42.8zM448 164c11 0 20 9 20 20v4h44 16c11 0 20 9 20 20s-9 20-20 20h-2l-1.6 4.5c-8.9 24.4-22.4 46.6-39.6 65.4c.9 .6 1.8 1.1 2.7 1.6l18.9 11.3c9.5 5.7 12.5 18 6.9 27.4s-18 12.5-27.4 6.9l-18.9-11.3c-4.5-2.7-8.8-5.5-13.1-8.5c-10.6 7.5-21.9 14-34 19.4l-3.6 1.6c-10.1 4.5-21.9-.1-26.4-10.2s.1-21.9 10.2-26.4l3.6-1.6c6.4-2.9 12.6-6.1 18.5-9.8l-12.2-12.2c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0l14.6 14.6 .5 .5c12.4-13.1 22.5-28.3 29.8-45H448 376c-11 0-20-9-20-20s9-20 20-20h52v-4c0-11 9-20 20-20z"></path>
</svg>`

const summarizeIcon = `
<svg class='dropdown-item-icon' style="width:16px; height:16px; fill:#444;"  viewBox="0 0 640 512" xmlns="http://www.w3.org/2000/svg">
  <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
  <path d="M9.4 9.4C21.9-3.1 42.1-3.1 54.6 9.4L160 114.7V96c0-17.7 14.3-32 32-32s32 14.3 32 32v96c0 4.3-.9 8.5-2.4 12.2c-1.6 3.7-3.8 7.3-6.9 10.3l-.1 .1c-3.1 3-6.6 5.3-10.3 6.9c-3.8 1.6-7.9 2.4-12.2 2.4H96c-17.7 0-32-14.3-32-32s14.3-32 32-32h18.7L9.4 54.6C-3.1 42.1-3.1 21.9 9.4 9.4zM256 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM114.7 352H96c-17.7 0-32-14.3-32-32s14.3-32 32-32h96 0l.1 0c8.8 0 16.7 3.6 22.5 9.3l.1 .1c3 3.1 5.3 6.6 6.9 10.3c1.6 3.8 2.4 7.9 2.4 12.2v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V397.3L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L114.7 352zM416 96c0-17.7 14.3-32 32-32s32 14.3 32 32v18.7L585.4 9.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L525.3 160H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H448c-8.8 0-16.8-3.6-22.6-9.3l-.1-.1c-3-3.1-5.3-6.6-6.9-10.3s-2.4-7.8-2.4-12.2l0-.1v0V96zM525.3 352L630.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L480 397.3V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V320v0c0 0 0-.1 0-.1c0-4.3 .9-8.4 2.4-12.2c1.6-3.8 3.9-7.3 6.9-10.4c5.8-5.8 13.7-9.3 22.5-9.4c0 0 .1 0 .1 0h0 96c17.7 0 32 14.3 32 32s-14.3 32-32 32H525.3z"></path>
</svg>
`

const findActionItemsIcon = `
<svg class='dropdown-item-icon' style="width:16px; height:16px; fill:#444444;"  viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
  <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
  <path d="M64 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zM64 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm48-208a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"></path>
</svg>
`

const explainIcon = `
<svg class='dropdown-item-icon' style="width:16px; height:16px; fill:#444444;"  viewBox="0 0 320 512" xmlns="http://www.w3.org/2000/svg">
  <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
  <path d="M80 160c0-35.3 28.7-64 64-64h32c35.3 0 64 28.7 64 64v3.6c0 21.8-11.1 42.1-29.4 53.8l-42.2 27.1c-25.2 16.2-40.4 44.1-40.4 74V320c0 17.7 14.3 32 32 32s32-14.3 32-32v-1.4c0-8.2 4.2-15.8 11-20.2l42.2-27.1c36.6-23.6 58.8-64.1 58.8-107.7V160c0-70.7-57.3-128-128-128H144C73.3 32 16 89.3 16 160c0 17.7 14.3 32 32 32s32-14.3 32-32zm80 320a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"></path>
</svg>
`

const expandRightIcon = `
<svg class='dropdown-item-icon' style="width:12px; height:12px; fill:#444444; margin-left: auto;"  viewBox="0 0 320 512" xmlns="http://www.w3.org/2000/svg">
  <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
  <path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"></path>
</svg>
`

const doneIcon = `
    <svg width="16" height="16" class="dropdown-item-icon" fill="#878787" viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg">
        <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
        <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"></path>
    </svg>
`;

const continueWritingIcon = `
    <svg width="16" height="16" class="dropdown-item-icon" fill="#878787" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
        <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
        <path d="M373.5 27.1C388.5 9.9 410.2 0 433 0c43.6 0 79 35.4 79 79c0 22.8-9.9 44.6-27.1 59.6L277.7 319l-10.3-10.3-64-64L193 234.3 373.5 27.1zM170.3 256.9l10.4 10.4 64 64 10.4 10.4-19.2 83.4c-3.9 17.1-16.9 30.7-33.8 35.4L24.4 510.3l95.4-95.4c2.6 .7 5.4 1.1 8.3 1.1c17.7 0 32-14.3 32-32s-14.3-32-32-32s-32 14.3-32 32c0 2.9 .4 5.6 1.1 8.3L1.7 487.6 51.5 310c4.7-16.9 18.3-29.9 35.4-33.8l83.4-19.2z"></path>
    </svg>
`;

const makeLongerIcon = `
    <svg width="16" height="16" class="dropdown-item-icon" fill="#878787" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg">
        <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
        <path d="M151.6 469.6C145.5 476.2 137 480 128 480s-17.5-3.8-23.6-10.4l-88-96c-11.9-13-11.1-33.3 2-45.2s33.3-11.1 45.2 2L96 365.7V64c0-17.7 14.3-32 32-32s32 14.3 32 32V365.7l32.4-35.4c11.9-13 32.2-13.9 45.2-2s13.9 32.2 2 45.2l-88 96zM320 32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128H544c17.7 0 32 14.3 32 32s-14.3 32-32 32H320c-17.7 0-32-14.3-32-32s14.3-32 32-32z"></path>
    </svg>
`;

const tryAgainIcon = `
    <svg width="16" height="16" class="dropdown-item-icon" fill="#878787" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
        <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
        <path d="M386.3 160H336c-17.7 0-32 14.3-32 32s14.3 32 32 32H464c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v51.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0s-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3s163.8-62.5 226.3 0L386.3 160z"></path>
    </svg>
`;

const closeIcon = `
    <svg width="16" height="16" class="dropdown-item-icon" fill="#878787" viewBox="0 0 384 512" xmlns="http://www.w3.org/2000/svg">
        <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
        <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"></path>
    </svg>
`;

const actions = [
    {
        type: 'Summarize',
        icon: summarizeIcon,
    },
    {
        type: 'Translate',
        icon: translateIcon
    },
    {
        type: 'Find action items',
        icon: findActionItemsIcon
    },
    {
        type: 'Explain this',
        icon: explainIcon
    },
]

const responseActions = [
    {
        type: 'Done',
        icon: doneIcon,
    },
    {
        type: 'Continue writing',
        icon: continueWritingIcon,
    },
    {
        type: 'Make longer',
        icon: makeLongerIcon,
    },
    {
        type: 'Try again',
        icon: tryAgainIcon,
    },
    {
        type: 'Close',
        icon: closeIcon,
    }
]

const csrfToken = document.querySelector('meta[name=token]').getAttribute('content');

const events = {};
let reader = null;
let lastAction = null;
let lastQuery = '';
let isAiThinking = false;
let isAiWriting = false;
let lastContext = '';

const stopStreamingEvent = new Event('stop-streaming');

const parser = new DOMParser();
const decoder = new TextDecoder();

const enableInput = (input) => {
    input.value = '';
    input.removeAttribute('disabled');
    input.placeholder = 'Ask AI...';
}

const disableInput = (input) => {
    input.setAttribute('disabled', 'disabled');
    input.placeholder = 'AI is writing...';
    input.value = '';
}

function removeEvents() {
    window.removeEventListener('resize', events.onScrollOrResize);
    document.querySelector('#html-editor_ifr').contentWindow.removeEventListener('scroll', events.onScrollOrResize);
    document.removeEventListener('keydown', events.onDocumentKeydown);
    document.querySelector('#html-editor_ifr').contentWindow.removeEventListener('keydown', events.onIfrKeydown);
    document.removeEventListener('mousedown', events.onMousedown);
    document.querySelector('#html-editor_ifr').contentWindow.removeEventListener('mousedown', events.onMousedown);
};

const removeTooltipAndEvents = () => {
    const tooltip = document.getElementById('ask-ai-tooltip');
    tooltip.remove();
    removeEvents();
}

const parse = (text) => {
    const parsedText = parser.parseFromString(text, 'text/html');
    return parsedText.body.innerHTML
}

function createAiActionsDropdown(editor, input, tooltip, currentLine, tmceEditorIframe) {
    // Create AI actions container
    const aiActionsContainer = createElement('div', 'edit-ai-input-actions-container', ['edit-ai-actions-container', 'anim', 'd-none']);
    const tryAgainBtn = createElement('div', 'try-again', ['edit-ai-input-action-button'], {}, 'Try again');
    const stopBtn = createElement('div', 'stop-action', ['edit-ai-input-action-button'], {}, 'Stop');
    const tryAgainShortcutText = createElement('span', '', ['edit-ai-input-action-shortcut'], {}, 'R');
    const stopShortcutText = createElement('span', '', ['edit-ai-input-action-shortcut'], {}, 'Esc');

    tryAgainBtn.role = 'button';
    stopBtn.role = 'button';

    tryAgainBtn.appendChild(tryAgainShortcutText);
    stopBtn.appendChild(stopShortcutText);
    aiActionsContainer.appendChild(tryAgainBtn);
    aiActionsContainer.appendChild(stopBtn);
    const tryAgainCallback = async () => {
        if (!isAiWriting) {
            return;
        }

        await stopStreamResponse(reader);
        document.dispatchEvent(stopStreamingEvent);
        isAiWriting = false;

        if (lastAction.split('-')[0] === 'translate') {
            const language = lastAction.split('-')[1];
            handleDropdownOptionClick('translate', currentLine, tooltip, language, tmceEditorIframe, true);
        }
        handleDropdownOptionClick(lastAction, currentLine, tooltip, lastAction === 'ask-ai-basic' ? lastQuery : '', tmceEditorIframe, true);
    }

    tryAgainBtn.addEventListener('click', tryAgainCallback);

    stopBtn.addEventListener('click', async () => {
        if (!isAiThinking) {
            removeTooltipAndEvents();
        }
        if (isAiWriting) {
            const closeConfirm = await popconfirm();
            if (closeConfirm) {
                stopStreamResponse(reader);
                document.dispatchEvent(stopStreamingEvent);
                removeTooltipAndEvents();
            }
        }
    });

    document.addEventListener('keydown', e => {
        if (e.key === 'r' && reader) {
            tryAgainCallback();
        } 
    });
    return aiActionsContainer;
}

const createOrGetDropdown = (selector) => {
    let dropdown = document.getElementById(`${selector}`);
    if (!dropdown) {
        dropdown = createElement('div', `${selector}`, [`${selector}`, 'anim', 'fadeIn', 'd-none']);
        const dropdownItems = [];

        if (selector === SELECTORS.RESPONSE_DROPDOWN) {
            responseActions.forEach(action => {
                const id = action.type.toLowerCase().replace(' ', '-');
                const aiResponseActionElement = createElement('div', `${id}`, ['ask-ai-dropdown-item'], {}, action.type);
                dropdownItems.push(aiResponseActionElement);

                aiResponseActionElement.insertAdjacentHTML('afterbegin', action.icon);
                dropdown.appendChild(aiResponseActionElement);
            });
        };
    };
    return dropdown
}

const handleResponseAction = async (tooltip, currentLine, tmceEditorIframe) => {
    const editor = tinymce.activeEditor;
    const input = tooltip.querySelector('input');
    let res = currentLine.innerHTML

    const aiResponseActionDropdown = createOrGetDropdown(SELECTORS.RESPONSE_DROPDOWN);
    const dropdownItems = aiResponseActionDropdown.querySelectorAll('.ask-ai-dropdown-item');
    tooltip.appendChild(aiResponseActionDropdown);
    showElement(SELECTORS.RESPONSE_DROPDOWN);

    enableInput(input);
   
    const responseEvents = {};

    const choice = await new Promise((resolve) => {
        responseEvents.onDropdownItemClick = (e) => {
            resolve(e.target.closest('.ask-ai-dropdown-item').getAttribute('id'));
        }
        dropdownItems.forEach(async dropdownItem => {
            dropdownItem.addEventListener('click', responseEvents.onDropdownItemClick);
            document.body.addEventListener('mousedown', (e) => {
                if (!tooltip.contains(e.target) && !isAiThinking) {
                    resolve('close');
                }
            })
        })
        document.querySelector('#html-editor_ifr').contentWindow.addEventListener('mousedown', (e) => {
            if (!tooltip.contains(e.target) && !isAiThinking) {
                resolve('close');
            } 
        })
        document.addEventListener('stop-streaming', () => {
            dropdownItems.forEach(dropdownItem => {
                dropdownItem.removeEventListener('click', responseEvents.onDropdownItemClick);
            })
         }, { once: true })
    })

    dropdownItems.forEach(dropdownItem => {
        dropdownItem.removeEventListener('click', responseEvents.onDropdownItemClick);
    })

    document.activeElement.blur();
    disableInput(input);
    hideElement('ai-response-dropdown')
    
    if (choice === 'done') {
        tooltip?.remove();
        const selection = editor.selection.getContent({ format: 'text/html' });
        editor.selection.setContent(selection, { format: 'text/html' });
        editor.focus();
    }
    if (choice === 'close') {
        tooltip?.remove();
    }
    if (choice === 'try-again') {
        if (lastAction.split('-')[0] === 'translate') {
            const language = lastAction.split('-')[1];
            handleDropdownOptionClick('translate', currentLine, tooltip, language, tmceEditorIframe, true);
        }
        
        handleDropdownOptionClick(lastAction, currentLine, tooltip, lastAction === 'ask-ai-basic' ? lastQuery : '', tmceEditorIframe, true);
    }
    if (choice === 'continue-writing' || choice === 'make-longer') {
        lastContext = res;
        isAiThinking = true;
        const continuation = await fetch(`${window.location.origin}/ai/edit/${choice}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': csrfToken,
            },
            body: JSON.stringify({
                context: res,
            }),
        })

        if (continuation.status !== 200) {
            try {
                const resJson = await response.json();
                currentLine.innerHTML = resJson.error;
            }
            catch (e) {
                currentLine.innerHTML = 'An error occurred. Please try again. Or contact CogniVis administrator.';
            }
            return;
        }

        if (choice === 'make-longer') {
            res = ''
        }

        reader = continuation.body.getReader();
        while (true) {
            isAiWriting = true;
            // eslint-disable-next-line no-await-in-loop
            const { done, value } = await reader.read();
            if (done) {
                isAiWriting = false;
                isAiThinking = false;
                editor.undoManager.add();
                break;
            }; // Exit the loop if the stream is finished
            
            const chunk = decoder.decode(value);
            res += chunk

            currentLine.innerHTML = parse(res);
            calculateTooltipPosition(tooltip, tmceEditorIframe, currentLine);
        }

        editor.selection.select(currentLine)
        
        handleResponseAction(tooltip, currentLine, tmceEditorIframe);    
    }
}

const askAi = async (tooltip, tmceEditorIframe, currentLine, action, query = '', isTryAgain = false) => {
    const input = document.getElementById(SELECTORS.INPUT)
    const editor = tinymce.activeEditor;
    const ctx = `${editor.selection.getContent() || editor.getContent()}`;
    document.activeElement.blur();
    input.setAttribute('disabled', 'true');
    input.setAttribute('placeholder', 'AI is writing...');

    if (!isTryAgain) {
        lastContext = ctx;
        lastAction = action;
        lastQuery = query;
    }

    isAiThinking = true;
    const response = await fetch(`${window.location.origin}/ai/edit/${action}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': csrfToken,
        },
        body: JSON.stringify({
            query: isTryAgain ? lastQuery : query,
            context: isTryAgain ? lastContext : ctx,
            action: action,
        }),
    });

    if (response.status !== 200) {
        try {
            const resJson = await response.json();
            currentLine.innerHTML = resJson.error;
        }
        catch (e) {
            currentLine.innerHTML = 'An error occurred. Please try again. Or contact CogniVis administrator.';
        }
        return { error: true }
    }

    showElement('edit-ai-input-actions-container');
    hideElement('ask-ai-focus-or-close-info');
    hideElement('ai-response-dropdown');
    
    reader = response.body.getReader();
    let res = '';
    while (true) {
        // eslint-disable-next-line no-await-in-loop
        const { done, value } = await reader.read();
        isAiWriting = true;
        
        if (done) { 
            editor.selection.select(currentLine);
            isAiWriting = false;
            isAiThinking = false;
            editor.undoManager.add();
            hideElement('edit-ai-input-actions-container');
            showElement('ask-ai-focus-or-close-info');
            break; // Exit the loop if the stream is finished
        }

        const chunk = decoder.decode(value);
        res += chunk
        currentLine.innerHTML = parse(res);

        calculateTooltipPosition(tooltip, tmceEditorIframe, currentLine);
    }

    return { error: false }
}
const handleDropdownOptionClick = async (action, currentLine, tooltip, query = '', tmceEditorIframe, isTryAgain = false) => {
    const { error } = await askAi(tooltip, tmceEditorIframe, currentLine, action, query, isTryAgain);

    if (error) {
        hideElement('ask-ai-tooltip');
        return
    }
    handleResponseAction(tooltip, currentLine, tmceEditorIframe);
}

function calculateTooltipPosition(tooltip, tmceEditorIframe, currentLine) {
    const editorRect = tmceEditorIframe.getBoundingClientRect();
    const currentLineRect = currentLine.getBoundingClientRect();

    tooltip.style.top = `${editorRect.top + currentLineRect.top + currentLineRect.height}px`;
    tooltip.style.left = `${editorRect.left + currentLineRect.left}px`;
    tooltip.style.width = `${currentLineRect.width}px`;
}

function showAskAiTooltip(editor, currentLine) {
    const existingTooltip = document.getElementById('ask-ai-tooltip');
    if (existingTooltip) {
        existingTooltip.remove();
    }

    const tmceEditorIframe = editor.getContainer().querySelector('iframe');

    const focusOrCloseInfo = createElement('span', 'ask-ai-focus-or-close-info', ['ask-ai-focus-or-close-info', 'anim', 'fadeIn'], {}, 'Press Tab to focus, Esc to close');
    const tooltip = document.createElement('div');
    tooltip.id = 'ask-ai-tooltip';
    tooltip.classList.add('ask-ai-dropdown');
    tooltip.classList.add('anim');
    tooltip.style.position = 'absolute';
    tooltip.style.zIndex = '1000';

    calculateTooltipPosition(tooltip, tmceEditorIframe, currentLine);

    const dropdown = createOrGetDropdown(SELECTORS.ACTIONS_DROPDOWN);
    const dropdownLabel = createElement('div', 'ask-ai-dropdown-label', ['ask-ai-dropdown-label'], {}, 'Generate from page');
    dropdown.appendChild(dropdownLabel);
    
    actions.forEach(action => {
        if (action.type === 'Translate') {
            const dropdownItem = createElement('div', 'translate', ['ask-ai-dropdown-item', 'position-relative'], {});

            const languagesDropdown = createElement('div', 'ask-ai-languages-dropdown', [SELECTORS.ACTIONS_DROPDOWN, 'position-absolute', 'nested-dropdown']);
            dropdownItem.insertAdjacentHTML('afterbegin', translateIcon);
            dropdownItem.insertAdjacentHTML('beforeend', '<span>Translate</span>');
            dropdownItem.insertAdjacentHTML('beforeend', expandRightIcon);
            languages.forEach(language => {
                const id = language.toLowerCase().replaceAll(' ', '-');
                const langDropdownItem = createElement('div', `${id}`, ['ask-ai-dropdown-item'], {}, language);
                langDropdownItem.addEventListener('click', async () => {
                    dropdown.classList.add('d-none');
                    input.setAttribute('disabled', 'true');
                    input.setAttribute('placeholder', 'AI is writing...');
                    lastAction = `translate-${id}`
                    await handleDropdownOptionClick('translate', currentLine, tooltip, id, tmceEditorIframe);
                });
                languagesDropdown.appendChild(langDropdownItem);
            })
            dropdownItem.appendChild(languagesDropdown);
            dropdown.appendChild(dropdownItem);
            return
        }
        const id = action.type.toLowerCase().replaceAll(' ', '-');
        const dropdownItem = createElement('div', `${id}`, ['ask-ai-dropdown-item'], {}, action.type);
        dropdownItem.insertAdjacentHTML('afterbegin', action.icon);

        dropdownItem.addEventListener('click', async () => {
            dropdown.classList.add('d-none');
            input.setAttribute('disabled', 'true');
            input.setAttribute('placeholder', 'AI is writing...');
            lastAction = id;
            await handleDropdownOptionClick(id, currentLine, tooltip, '', tmceEditorIframe);
        });
        dropdown.appendChild(dropdownItem);
    })
    

    const form = document.createElement('form');
    const inputWrapper = document.createElement('div');
    inputWrapper.classList.add('ask-ai-input-wrapper')

    const input = document.createElement('input');
    input.id = 'ask-ai-input';
    input.type = 'text';
    input.placeholder = 'Ask AI...';
    input.style.width = '100%';
    input.style.height = '100%';
    input.style.boxSizing = 'border-box';
    input.classList.add('ask-ai-input');
    input.classList.add('anim');
    
    form.appendChild(inputWrapper);
    inputWrapper.appendChild(input);
    tooltip.appendChild(form);
    tooltip.appendChild(dropdown);
    const aiActionsContainer = createAiActionsDropdown(editor, input, tooltip, currentLine, tmceEditorIframe);
    inputWrapper.appendChild(aiActionsContainer);
    inputWrapper.appendChild(focusOrCloseInfo)

    document.body.appendChild(tooltip);

    const ctx = `${editor.selection.getContent() || editor.getContent()}`.trim();
    if (ctx) { 
        showElement(SELECTORS.ACTIONS_DROPDOWN);
    }


    events.onScrollOrResize = () => {
        calculateTooltipPosition(tooltip, tmceEditorIframe, currentLine);
    }
    window.addEventListener('resize', events.onScrollOrResize);
    document.querySelector('#html-editor_ifr').contentWindow.addEventListener('scroll', events.onScrollOrResize);

    events.onDocumentKeydown = (e) => {
        if (document.getElementById('ask-ai-tooltip') && e.code === 'Escape' && !isAiThinking) {
            removeTooltipAndEvents()
        };
    };
    document.addEventListener('keydown', events.onDocumentKeydown);

    events.onIfrKeydown = (e) => {
        if (!input) return;

        if (e.code === 'Tab') {
            e.preventDefault();
            input.focus();
            return;
        }

        if (e.code === 'Escape') {
            stopStreamResponse(reader);
            document.dispatchEvent(stopStreamingEvent);
            removeTooltipAndEvents();
            return;
        }
        if (document.activeElement === tmceEditorIframe && e.code !== 'Space') {
            removeTooltipAndEvents()
        }
    }
    document.querySelector('#html-editor_ifr').contentWindow.addEventListener('keydown', events.onIfrKeydown);

    events.onMousedown = async (e) => {
        if (!document.getElementById('ask-ai-tooltip') || e.target.closest('#ask-ai-tooltip')) return;
        if (!isAiWriting && isAiThinking) e.preventDefault();
        if (!isAiThinking) {
            removeTooltipAndEvents();
        }
        if (isAiWriting) {
            const closeConfirm = await popconfirm();
            if (closeConfirm) {
                stopStreamResponse(reader);
                document.dispatchEvent(stopStreamingEvent);
                removeTooltipAndEvents();
            }
        }
    }
    document.addEventListener('mousedown', events.onMousedown);
    document.querySelector('#html-editor_ifr').contentWindow.addEventListener('mousedown', events.onMousedown);

    form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const input = e.target[0];
        const query = input.value;

        hideElement('ai-response-dropdown');
        hideElement(SELECTORS.ACTIONS_DROPDOWN);

        const { error } = await askAi(tooltip, tmceEditorIframe, currentLine, 'ask-ai-basic', query);

        if (error) {
            hideElement('ask-ai-tooltip');
            return
        }
        handleResponseAction(tooltip, currentLine, tmceEditorIframe)
    });
}


/**
 * @param {Editor} editor
 */
function register(editor) {
    editor.on('KeyUp', e => {
        const currentLine = editor.selection.getNode();
        const tooltip = document.getElementById('ask-ai-tooltip');
        if (currentLine.innerText.trim() !== '' || tooltip) return;

        if (e.code === 'Space') {
            showAskAiTooltip(editor, currentLine);
        }
    });
}

document.addEventListener('keydown', async e => {
    const input = document.getElementById('ask-ai-input');
    if (!input) return;

    if (e.code === 'Tab') {
        e.preventDefault();

        input.focus();
    }

    if (e.code === 'Escape') {
        if (isAiThinking) {
            const closeConfirm = await popconfirm();
            if (closeConfirm) {
                stopStreamResponse(reader);
                document.dispatchEvent(stopStreamingEvent);
                removeTooltipAndEvents();
            }
        }
    }
})

/**
 *
 * @param {WysiwygConfigOptions} providedOptions
 * @return {function(Editor, string)}
 */
export function getPlugin(providedOptions) {
    options = providedOptions;
    return register;
}
